import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Link from '../../../components/Link';
import CourseItem from '../../../components/CourseItem/CourseItem';
import SkholeIcon11 from '../../../components/statelessComponents/Icons/SkholeIcon11';
import SkholeIcon09 from '../../../components/statelessComponents/Icons/SkholeIcon09';
import messages from '../coursesMessges';
import s from './ContinueLearning.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var ContinueLearning = (_dec = withStyles(s), injectIntl(_class = _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(ContinueLearning, _React$Component);
  var _super = _createSuper(ContinueLearning);
  function ContinueLearning() {
    _classCallCheck(this, ContinueLearning);
    return _super.apply(this, arguments);
  }
  _createClass(ContinueLearning, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        tasks = _this$props.tasks,
        course = _this$props.course,
        exam = _this$props.exam,
        quiz = _this$props.quiz,
        unreadNotifications = _this$props.unreadNotifications,
        user = _this$props.user,
        _this$props$afterCour = _this$props.afterCourseRemovedFromFavorite,
        afterCourseRemovedFromFavorite = _this$props$afterCour === void 0 ? function () {} : _this$props$afterCour,
        _this$props$handleOpe = _this$props.handleOpenNotificationPopover,
        handleOpenNotificationPopover = _this$props$handleOpe === void 0 ? function () {} : _this$props$handleOpe,
        inRow = _this$props.inRow;
      return /*#__PURE__*/_jsx("div", {
        className: s.continueLearning
      }, void 0, /*#__PURE__*/_jsx("h2", {}, void 0, course && (_.get(user, 'loginNumber', 0) > 1 || !!_.get(course, 'progress', 0)) && /*#__PURE__*/React.createElement(FormattedMessage, messages.continueLearningTitle), _.get(user, 'loginNumber', 0) <= 1 && course && _.get(course, 'progress', 0) === 0 && /*#__PURE__*/React.createElement(FormattedMessage, messages.startLearningTitle)), /*#__PURE__*/_jsx("div", {
        className: classNames(s.continueLearningContent, inRow && s.landscapeIphonePixel)
      }, void 0, !_.isEmpty(course) && /*#__PURE__*/_jsx("div", {
        className: classNames(s.dashboardCourseItemContainer, inRow && s.landscapeIphonePixelContainer)
      }, void 0, /*#__PURE__*/_jsx(CourseItem, {
        item: course,
        disableHover: true,
        isInDashboard: true,
        afterCourseRemovedFromFavorite: afterCourseRemovedFromFavorite
      })), /*#__PURE__*/_jsx("div", {
        className: s.dashboardStats
      }, void 0, tasks > 0 && /*#__PURE__*/_jsx(Link, {
        to: "/tasks"
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.notificationBadge
      }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, tasks)), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.taskToDoText, {
        values: {
          amount: tasks || 0
        }
      }))), !_.isEmpty(exam) && /*#__PURE__*/_jsx(Link, {
        to: "/tasks",
        className: classNames(s.examText, s.hideOnMobile)
      }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(SkholeIcon11, {
        className: s.examScoreIcon
      })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.examScoreText, {
        values: {
          score: "".concat(_.get(exam, 'totalPoints', 0), "/").concat(_.get(exam, 'quizPoints', 0)),
          examName: "".concat(_.get(exam, 'taskId.name'))
        }
      }))), quiz && _.get(quiz, 'courseId.slug') && /*#__PURE__*/_jsx(Link, {
        to: "/courses/".concat(_.get(quiz, 'courseId.slug'), "/quizzes/").concat(quiz.quizId._id),
        className: classNames(s.examText, s.hideOnMobile)
      }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(SkholeIcon11, {
        className: s.examScoreIcon
      })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.quizScoreText, {
        values: {
          score: "".concat(_.get(quiz, 'totalPoints', 0), "/").concat(_.get(quiz, 'quizPoints', 0)),
          quizName: "".concat(_.get(quiz, 'quizId.name'))
        }
      }))), !!unreadNotifications && /*#__PURE__*/_jsx("span", {
        "data-test-id": "DiyD2lVZ-xh_EnEN_g7Cw",
        className: s.messagesText,
        role: "link",
        tabIndex: 0,
        onClick: handleOpenNotificationPopover,
        onKeyPress: handleOpenNotificationPopover
      }, void 0, /*#__PURE__*/_jsx(SkholeIcon09, {
        className: s.msgIcon
      }), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.haveMessagesText, {
        values: {
          amount: unreadNotifications
        }
      }))))));
    }
  }]);
  return ContinueLearning;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  course: undefined,
  afterCourseRemovedFromFavorite: function afterCourseRemovedFromFavorite() {},
  exam: undefined,
  quiz: undefined,
  inRow: false
}), _class2)) || _class) || _class);
export { ContinueLearning as default };